import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

class GroupForm extends Component {
    constructor(props) {
		super(props);
		var data = this.props.dataItem;
		console.log(this.props.dataItem.PositionGroupType);
		if (this.props.dataItem.PositionGroupId) {
			var positionGroupType = {
				positionGroupTypeId: this.props.dataItem.PositionGroupTypeId,
				description: this.props.dataItem.PositionGroupType,
				isActive: this.props.dataItem.IsActive
			}
			
			data.positionGroupType = positionGroupType;
			delete data.PositionGroupType;
		}
		
		this.state = {
			groupInEdit: data || null,
			value: [],           
			originalGroupName: this.props.dataItem.Description || '',
			//For comparing original name on edit
            groupNameMassage: '',
            typeMessage: Object.keys(this.props.dataItem).length == 0? 'Position group type is required':''
		};
	}

	// delayedCallback = debounce(() => {
	// 	axios
	// 		.get(`${ROOT_API_URL}/ManageDistrict/CheckUserByEmail?stateId=${this.state.groupInEdit.assignedLoginId}`)
	// 		.then((response) => {
	// 			console.log(response);
	// 			this.setState({
	// 				emailMessage: response.data.message
	// 			});
	// 		});
	// }, 2000);

	// onEmailChange = (event) => {
	// 	let target = event.target;
	// 	const value = target.type === 'checkbox' ? target.checked : target.value;
	// 	const name = target.props ? target.props.name : target.name;

	// 	const edited = this.state.groupInEdit;
	// 	edited[name] = value;
	// 	edited.isActive = true;
	// 	this.setState(
	// 		{
	// 			groupInEdit: edited,
	// 			emailMessage: ''
	// 		},
	// 		() => {
	// 			this.delayedCallback();
	// 		}
	// 	);
	// };
    
    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.originalGroupName != this.state.groupInEdit.Description) {
            axios
				.get(`${ROOT_API_URL}/ManagePositionGroup/CheckGroupName?groupName=${this.state.groupInEdit.Description}`, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
                        groupNameMassage: response.data.message
                    })
					var t = this.state;
                    if (this.state.typeMessage == '') {
                        if (this.state.groupNameMassage == '') {//if valid
                            if (this.state.groupInEdit.PositionGroupId) {//on edit
                                this.props.save(this.state.groupInEdit);
                                this.props.cancel();
                            }
                            else {
                                this.props.save(this.state.groupInEdit);
                                this.props.cancel();
                            }
                        }
                    }                 
                })
                .catch((response) => {
                    console.log(response);
                });
        }
        else {
			this.props.save(this.state.groupInEdit);
            this.props.cancel();
        }
	};
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
    onDialogInputChange = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.groupInEdit;
		edited[name] = value;
		this.setState({
            groupInEdit: edited,
            groupNameMassage: ''
		});
	};

	handleGroupTypeSelect = (event) => {
        const edited = this.state.groupInEdit;
        edited.positionGroupType = event.target.value;
		this.setState({
            groupInEdit: edited,
            typeMessage:''
		});
	};

	render() {
		return (
			<Dialog onClose={this.props.cancel}>
                {!this.state.groupInEdit.PositionGroupId ?
                    <h2 className="adjust-dist-title">Add New Position Group</h2> :
                    <h2 className="adjust-dist-title">Edit Position Group</h2>}
				<form className="user-form" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-6 col-lg-4">
						<label htmlFor="Description">Group Name</label>
						<Input
							required={true}
							type="text"
							name="Description"
							id="Description"
							value={this.state.groupInEdit.Description || ''}
							onChange={this.onDialogInputChange}
                        />
                        <p className="error-message">{this.state.groupNameMassage}</p>
					</div>

					{/* <div>
						<label>
							Ranger Email<br />
							<Input
							required={true}
							type="email"
							name="assignedLoginId"
							value={this.state.groupInEdit.assignedLoginId || ''}
							onChange={this.onDialogInputChange}
							/>
						</label>
						<p>{this.state.emailMessage}</p>
					</div> */}

					<div className="form-group col-md-6 col-lg-4">
						<label htmlFor="positionGroupType">Position Group Type</label>
						<DropDownList
							data={this.props.groupTypes}
							onChange={this.handleGroupTypeSelect}
							value={this.state.groupInEdit.positionGroupType}
							textField="description"
							dataItemKey="positionGroupTypeId"
							allowCustom={true}
							name="positionGroupType"
							id="positionGroupType"
                        />
                        <p className="error-message">{this.state.typeMessage}</p>
					</div>
					<DialogActionsBar>
                        <div className="adjust-btns">
							<div className="form-group">
								<button className="admin-k-button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
								{!this.state.groupInEdit.PositionGroupId ? (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-save"></i>
										<span>SAVE</span>
									</button>
								) : (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-edit"></i>
										<span>UPDATE</span>
									</button>
								)}
							</div>
						</div>
					</DialogActionsBar>
				</form>
			</Dialog>
		);
	}
}

export default GroupForm;
